// frontend/src/services/StuntGroupService.js
import axios from 'axios';

class StuntGroupService {
  // CRUD de base pour les stunt groups
  getAllStuntGroups(sessionId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups`);
  }

  createStuntGroup(sessionId, stuntGroup) {
    return axios.post(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups`, stuntGroup);
  }

  updateStuntGroup(sessionId, groupId, stuntGroup) {
    return axios.put(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups/${groupId}`, stuntGroup);
  }

  deleteStuntGroup(sessionId, groupId) {
    return axios.delete(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups/${groupId}`);
  }

  // Gestion des danseurs dans un groupe
  addDancersToGroup(sessionId, groupId, dancerIds) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups/${groupId}/dancers`,
      { dancer_ids: dancerIds }
    );
  }

  removeDancerFromGroup(sessionId, groupId, dancerId) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups/${groupId}/dancers/${dancerId}`
    );
  }

  // Gestion des stunts dans un groupe
  addStuntsToGroup(sessionId, groupId, stuntIds) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups/${groupId}/stunts`,
      { stunt_ids: stuntIds }
    );
  }

  removeStuntFromGroup(sessionId, groupId, stuntId) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunt_groups/${groupId}/stunts/${stuntId}`
    );
  }
}

export default new StuntGroupService();
